import { render } from "./App.vue?vue&type=template&id=186d5bed"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=186d5bed&lang=css"

import exportComponent from "/codebuild/output/src911820074/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__